import React from 'react';
import { colors, spaces } from 'globalStyle';
import { Text } from 'components/Texts';
import styled, { css } from 'styled-components';

export const Steps = ({ active = 1, fields = 2 }) => {
  if (fields === 0) return null;

  const sequence = new Array(fields).fill(0).map((n, index) => index + 1);
  const step = parseInt(active, 10);
  if (step > fields) return null;

  return (
    <div>
      <Grid mb={10}>
        {sequence.map((index) => <Bar key={index} active={index === step} />)}
      </Grid>
      <Text number={4}>
        Paso
        {' '}
        {step}
        {' '}
        de
        {' '}
        {fields}
      </Text>
    </div>
  );
};

const Grid = styled.div`
    ${spaces}
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(64px, 64px));
    grid-auto-rows: minmax(10px, auto);
    gap: 7px 7px;
    width: 100%;
    min-width: 100%;
    max-width: 100%;
`;

const Bar = styled.div`
    border-radius: 3px;
    width: 64px;
    height: 10px;
    background-color: ${colors.GRAY_3};

    ${(props) => props.active && css`
        background-color: ${colors.primary};
    `}
`;
